import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import {
  ViewerSkeleton,
  ViewerErrorState,
} from "../FileViewerStates/FileViewerStates";
import {
  ViewerZoomToolbar,
  useViewerZoom,
  useViewerFullscreen,
} from "../FileViewerStates/FileViewerToolbar";

const TextViewer = ({ fileUrl, fillHeight = false }) => {
  const containerRef = useRef(null);
  const [text, setText] = useState(null);
  const [error, setError] = useState(null);
  const [retryKey, setRetryKey] = useState(0);

  const { scale, zoomIn, zoomOut, reset } = useViewerZoom();
  const { isFullScreen, toggle: toggleFullscreen } =
    useViewerFullscreen(containerRef);

  useEffect(() => {
    let cancelled = false;
    setText(null);
    setError(null);
    fetch(fileUrl)
      .then((r) =>
        r.ok ? r.text() : Promise.reject(new Error(`HTTP ${r.status}`))
      )
      .then((t) => {
        if (!cancelled) setText(t);
      })
      .catch((e) => {
        if (!cancelled) setError(e.message || "Failed to load file");
      });
    return () => {
      cancelled = true;
    };
  }, [fileUrl, retryKey]);

  if (error) {
    return (
      <Box sx={{ height: fillHeight ? "100%" : "500px", bgcolor: "#fff" }}>
        <ViewerErrorState onRetry={() => setRetryKey((k) => k + 1)} />
      </Box>
    );
  }

  if (text == null) {
    return (
      <Box sx={{ height: fillHeight ? "100%" : "500px", bgcolor: "#fff" }}>
        <ViewerSkeleton />
      </Box>
    );
  }

  return (
    <Box
      ref={containerRef}
      sx={{
        position: "relative",
        height: fillHeight ? "100%" : "500px",
        bgcolor: "#fff",
      }}
    >
      <Box sx={{ height: "100%", overflow: "auto", pb: 7 }}>
        <pre
          style={{
            padding: "20px 24px",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            fontFamily:
              "ui-monospace, SFMono-Regular, Menlo, Monaco, 'Courier New', monospace",
            fontSize: `${13 * scale}px`,
            lineHeight: 1.6,
            margin: 0,
            color: "#111827",
          }}
        >
          {text}
        </pre>
      </Box>

      <ViewerZoomToolbar
        scale={scale}
        onZoomIn={zoomIn}
        onZoomOut={zoomOut}
        onReset={reset}
        isFullScreen={isFullScreen}
        onToggleFullscreen={toggleFullscreen}
      />
    </Box>
  );
};

export default TextViewer;
